import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import Alert from 'react-s-alert';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
import { Grid, withStyles, Tooltip, Fab } from '@material-ui/core';
import * as Icons from '@material-ui/icons';
import classnames from 'classnames';
import _ from 'lodash';
import socketIOClient from 'socket.io-client';
import Loader from '../../components/Loader/LoaderView';
import moment from 'moment';
// import { messaging } from '../../firebase';
import CustomContentTemplate from '../dashboard/components/Alert/CustomContentTemplate';
import Widget from '../../components/Widget';
import { Typography } from '../../components/Wrappers';
import NewWarning from '../dashboard/components/NewWarning';
import 'font-awesome/css/font-awesome.min.css';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/flip.css';
import '../dashboard/style.css';
import iconJump from '../../images/Presense/Action/icon-jump.png';
import iconNoMovement from '../../images/Presense/Action/icon-nomovement.png';
import iconNosignal from '../../images/Presense/DeviceSignal/icon-nosignal.png';
import iconGetUp from '../../images/Presense/Action/icon-stand.png';
import config from '../../config';
export class LogActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      modules: [],
      ward: '',
      response: false,
      endpoint: `${config.api.url}`,
    };
  }

  async componentDidMount() {
    const { endpoint } = this.state;
    const socket = socketIOClient(endpoint);
    await this.props.dashboard.getPatientForSubgroup();
    await this.props.router.getRouters();
    const dashboard = this;

    socket.on('change', async (payload) => {
      const { user, dbStatus, routerNoSignal } = dashboard.props.dashboard.toJS();
      if (payload.data.dbStatus === 'true') {
        if (dbStatus.status === false && dbStatus.id) {
          Alert.close(dbStatus.id);
          dashboard.props.dashboard.resetDbStatus();
        }
      } else {
        if (dbStatus.status === true && dbStatus.id === null) {
          let alertDb = Alert.error('Header', {
            customFields: {
              dbStatus: false,
            },
            position: 'bottom',
            timeout: 'none',
            type: 'critical',
          });
          dashboard.props.dashboard.setAlertDb(alertDb);
        }
      }

      if (payload.data.routerSerial && payload.data.deviceSerial === '') {
        let router = routerNoSignal.find((val) => val.routerId === payload.data.routerSerial);
        if (!router) {
          let alertDb = Alert.error('Header', {
            customFields: {
              dbStatus: true,
              router: payload.data.routerSerial,
            },
            position: 'bottom',
            timeout: 'none',
            type: 'critical',
          });
          dashboard.props.dashboard.setAlertRouter(payload.data.routerSerial, alertDb);
        }
      } else {
        let router = routerNoSignal.find((val) => val.routerId === payload.data.routerSerial);
        if (router) {
          Alert.close(router.id);
          dashboard.props.dashboard.resetAlertRouter(payload.data.routerSerial);
        }
      }

      let dataUser = _.find(user, (element) => {
        if (element.patient) {
          return _.find(element.patient.devices, (device) => {
            return device.serial === payload.data.deviceSerial && device.status === 'ACTIVATE';
          });
        }
      });
      if (dataUser && payload && payload.data && payload.data.changed) {
        try {
          const changed = JSON.parse(payload.data.changed);
          if (
            (changed.a && this.validateChange('a', changed.a)) ||
            (changed.f && this.validateChange('f', changed.a)) ||
            changed.b
          ) {
            if (changed.f === 3 && payload.data.alertFall === 'true') {
              dashboard.props.dashboard.setAlert(payload.data.deviceSerial, 'critical');
            } else {
              if (
                (changed.a && payload.data.alertAction === 'true') ||
                (changed.b <= 20 && payload.data.alertAction === 'true')
              ) {
                dashboard.props.dashboard.setAlert(payload.data.deviceSerial, 'warning');
              }
              if (
                (changed.f && changed.f !== null && changed.f !== 3) ||
                (changed.a && payload.data.alertAction === 'false')
              ) {
                dashboard.props.dashboard.clearAlert(payload.data.deviceSerial);
              }
            }
            // set logs activity
            if (
              (changed.f && changed.f === 3) ||
              changed.a ||
              (changed.b < 20 && payload.data.alertAction === 'true')
            ) {
              const { patient } = this.props.dashboard.getAlertID(payload.data.deviceSerial);
              let activity = changed.f === 3 ? 12 : changed.a;
              if (changed.b < 20 && payload.data.alertAction === 'true') {
                activity = 8;
              }
              const dataTest = {
                id: Math.floor(Math.random() * 10000000 + 1),
                variant:
                  payload.data.alertFall === 'true'
                    ? 'error'
                    : payload.data.alertAction === 'true'
                      ? 'warning'
                      : 'primary',
                time: moment().format(),
                action: this.getMomentValue(activity),
                patient: patient,
                activity: activity,
                router: payload.data.routerSerial || '',
              };
              this.props.logActivity.addActivity(dataTest);
            }
            dashboard.props.dashboard.setAction(payload.data);
          }
        } catch (e) {
          console.log('error : payload', payload);
        }
      }
    });

    // messaging.onMessage(async payload => {
    //   console.log('firebase time (admin)', Date.now());
    //   console.log('firebase payload (admin)', payload);
    //   const { user, dbStatus, routerNoSignal } = dashboard.props.dashboard.toJS();
    //   if (payload.data.dbStatus === 'true') {
    //     if (dbStatus.status === false && dbStatus.id) {
    //       Alert.close(dbStatus.id);
    //       dashboard.props.dashboard.resetDbStatus();
    //     }
    //   } else {
    //     if (dbStatus.status === true && dbStatus.id === null) {
    //       let alertDb = Alert.error('Header', {
    //         customFields: {
    //           dbStatus: false,
    //         },
    //         position: 'bottom',
    //         timeout: 'none',
    //         type: 'critical'
    //       });
    //       dashboard.props.dashboard.setAlertDb(alertDb);
    //     }
    //   }

    //   if (payload.data.routerSerial && payload.data.deviceSerial === "") {
    //     let router = routerNoSignal.find(val => val.routerId === payload.data.routerSerial)
    //     if(!router){
    //       let alertDb = Alert.error('Header', {
    //         customFields: {
    //           dbStatus: true,
    //           router: payload.data.routerSerial
    //         },
    //         position: 'bottom',
    //         timeout: 'none',
    //         type: 'critical'
    //       });
    //       dashboard.props.dashboard.setAlertRouter(payload.data.routerSerial,alertDb);
    //     }
    //   }else{
    //     let router = routerNoSignal.find(val => val.routerId === payload.data.routerSerial)
    //     if(router){
    //       Alert.close(router.id);
    //       dashboard.props.dashboard.resetAlertRouter(payload.data.routerSerial);
    //     }
    //   }

    //   let dataUser = _.find(user, element => {
    //     if (element.patient) {
    //       return _.find(element.patient.devices, device => {
    //         return (
    //           device.serial === payload.data.deviceSerial &&
    //           device.status === 'ACTIVATE'
    //         );
    //       });
    //     }
    //   });
    //   if (dataUser && payload && payload.data && payload.data.changed) {
    //     try {
    //       const changed = JSON.parse(payload.data.changed);
    //       if ((changed.a && this.validateChange('a', changed.a)) || (changed.f && this.validateChange('f', changed.a)) || changed.b) {
    //         if (changed.f === 3 && payload.data.alertFall === 'true') {
    //           dashboard.props.dashboard.setAlert(
    //             payload.data.deviceSerial,
    //             'critical'
    //           );
    //         } else {
    //           if ((changed.a && payload.data.alertAction === 'true') || (changed.b <= 20 && payload.data.alertAction === 'true')) {
    //             dashboard.props.dashboard.setAlert(
    //               payload.data.deviceSerial,
    //               'warning'
    //             );
    //           }
    //           if ((changed.f && changed.f !== null && changed.f !== 3) || (changed.a && payload.data.alertAction === 'false')) {
    //             dashboard.props.dashboard.clearAlert(payload.data.deviceSerial);
    //           }
    //         }
    //         // set logs activity
    //         if ((changed.f && changed.f === 3) || changed.a || (changed.b < 20 && payload.data.alertAction === 'true')) {
    //           const { patient } = this.props.dashboard.getAlertID(payload.data.deviceSerial);
    //           let activity = changed.f === 3 ? 12 : changed.a;
    //           if (changed.b < 20 && payload.data.alertAction === 'true') {
    //             activity = 8;
    //           }
    //           const dataTest = {
    //             id: Math.floor((Math.random() * 10000000) + 1),
    //             variant: payload.data.alertFall === 'true' ? 'error' : payload.data.alertAction === 'true' ? 'warning' : 'primary',
    //             time: moment().format(),
    //             action: this.getMomentValue(activity),
    //             patient: patient,
    //             activity: activity,
    //             router: payload.data.routerSerial || ''
    //           }
    //           this.props.logActivity.addActivity(dataTest);
    //         }
    //         dashboard.props.dashboard.setAction(payload.data);
    //       }
    //     } catch (e) {
    //       console.log('error : payload', payload);
    //     }
    //   }
    // });
  }

  validateChange(task, value) {
    if (task === 'a') {
      switch (value) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 8:
        case 9:
        case 10:
        case 11:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 19:
          return true;
        default:
          return false;
      }
    }
    if (task === 'f') {
      switch (value) {
        case 0:
        case 1:
        case 2:
        case 3:
          return true;
        default:
          return false;
      }
    }
    if (task === 'b') {
      return true;
    }
    if (task === 'm') {
      return true;
    }
  }

  getContent = (users) => {
    const { classes, theme } = this.props;
    let result = users.map((data) => (
      <Grid item lg={3} md={4} sm={6} xs={12} key={data.id}>
        <Widget
          title={data.name}
          upperTitle
          bodyClass={classes.fullHeightBody}
          className={classes.card}
          data={data}
          hasPatient={data.patient != null}
        >
          {this.box(data, classes, theme)}
        </Widget>
      </Grid>
    ));
    return result;
  };

  getLoaderContent = () => {
    const users = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }];
    let result = users.map((data) => (
      <Grid item lg={3} md={4} sm={6} xs={12} key={data.id}>
        <ContentLoader
          height={160}
          width={260}
          speed={2}
          primaryColor='#f3f3f3'
          secondaryColor='#ecebeb'
          style={{ backgroundColor: 'white' }}
        >
          <rect x='16' y='18' rx='3' ry='3' width='174' height='19' />
          <rect x='14' y='93' rx='3' ry='3' width='46' height='5' />
          <circle cx='37' cy='122' r='18' />
          <circle cx='36' cy='61' r='10' />
          <rect x='63' y='53' rx='3' ry='3' width='127' height='12' />
          <rect x='110' y='93' rx='3' ry='3' width='46' height='5' />
          <circle cx='133' cy='122' r='18' />
          <circle cx='231' cy='122' r='18' />
          <rect x='208' y='92' rx='3' ry='3' width='46' height='5' />
          <circle cx='230' cy='70' r='15' />
          <rect x='232' y='15' rx='0' ry='0' width='9' height='9' />
          <rect x='232' y='26' rx='0' ry='0' width='9' height='9' />
          <rect x='232' y='37' rx='0' ry='0' width='9' height='9' />
        </ContentLoader>
      </Grid>
    ));
    return result;
  };

  handleSound = (value) => {
    if (value === 1) {
      this.setState({ soundError: this.state.soundError + 1 });
    } else {
      this.setState({ soundWarning: this.state.soundWarning + 1 });
    }
  };

  handleSoundStop = (value) => {
    if (value === 1) {
      this.setState({ soundError: this.state.soundError - 1 });
    } else {
      this.setState({ soundWarning: this.state.soundWarning - 1 });
    }
  };

  getStyles = (name, that) => {
    return {
      fontWeight:
        that.state.modules.indexOf(name) === -1
          ? that.props.theme.typography.fontWeightRegular
          : that.props.theme.typography.fontWeightMedium,
    };
  };

  accessibility = (activite) => {
    const { classes } = this.props;
    let result = '';
    switch (activite) {
      case 1:
      case 10:
      case 14:
      case 15:
      case 16:
      case 17:
        result = <Icons.LocalHotel className={classes.iconActivity} />;
        break;
      case 2:
        result = <Icons.AirlineSeatReclineNormal className={classes.iconActivity} />;
        break;
      case 3:
        // result = <Icons.Accessibility className={classes.iconActivity} />;
        result = <img src={iconGetUp} alt='getup' width='30' />;
        break;
      case 4:
        result = <Icons.DirectionsWalk className={classes.iconActivity} />;
        break;
      case 5:
        result = <Icons.DirectionsRun className={classes.iconActivity} />;
        break;
      case 6:
        result = <img src={iconJump} alt='jump' width='30' />;
        break;
      case 8:
        result = <Icons.BatteryAlert className={classes.iconActivity} />;
        break;
      case 9:
        result = <img src={iconNosignal} alt='nosignal' width='30' />;
        break;
      case 11:
        result = <img src={iconNoMovement} alt='nomovement' width='30' />;
        break;
      case 18:
        result = <Icons.ExploreOff className={classes.iconActivity} />;
        break;
      case 19:
        result = <Icons.Snooze className={classes.iconActivity} />;
        break;
      default:
        result = <Icons.Help className={classes.iconActivity} />;
        break;
    }
    return result;
  };

  battery = (level) => {
    const { classes } = this.props;
    let result = '';
    if (level === 0) {
      result = (
        <Tooltip title={level + '%'}>
          <Icons.BatteryAlert color='error' />
        </Tooltip>
      );
    } else if (level >= 1 && level <= 20) {
      result = (
        <Tooltip title={level + '%'}>
          <Icons.Battery20 className={classes.iconWarning} />
        </Tooltip>
      );
    } else if (level >= 21 && level < 50) {
      result = (
        <Tooltip title={level + '%'}>
          <Icons.Battery50 />
        </Tooltip>
      );
    } else if (level >= 50 && level < 100) {
      result = (
        <Tooltip title={level + '%'}>
          <Icons.Battery80 />
        </Tooltip>
      );
    } else if (level === 100) {
      result = (
        <Tooltip title={level + '%'}>
          <Icons.BatteryFull color='primary' />
        </Tooltip>
      );
    }
    return result;
  };

  getMomentValue = (value) => {
    let result = 'Unknow';
    switch (value) {
      case 1:
        result = 'Lying';
        break;
      case 2:
        result = 'Sitting';
        break;
      case 3:
        result = 'Standing';
        break;
      case 4:
        result = 'Walking';
        break;
      case 5:
        result = 'Running';
        break;
      case 6:
        result = 'Jumping';
        break;
      case 7:
        result = 'Movement';
        break;
      case 8:
        result = 'Low battery';
        break;
      case 9:
        result = 'No Signal';
        break;
      case 10:
        result = 'Not turn for';
        break;
      case 11:
        result = 'No movement for';
        break;
      case 12:
        result = 'Falling';
        break;
      case 13:
        result = 'Unknow';
        break;
      case 14:
        result = 'Lying on back';
        break;
      case 15:
        result = 'Lying on stomach';
        break;
      case 16:
        result = 'Lying on left side';
        break;
      case 17:
        result = 'Lying on right side';
        break;
      case 18:
        result = 'Out of area';
        break;
      case 19:
        result = 'Walking At Night';
        break;
      default:
        break;
    }
    return result;
  };

  actionStatus = (icon) => {
    const { classes } = this.props;
    return (
      <Fab
        color='default'
        aria-label='action'
        size='small'
        // disabled
        variant='extended'
        className={classes.activityBox}
      >
        {icon}
      </Fab>
      // <Avatar color="primary" >
      //   {icon}
      // </Avatar>
    );
  };

  getFullname = (language, data) => {
    let fullname = '';
    if (language && language === 'th-TH') {
      if (data.firstname || data.lastname) {
        fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
      } else {
        fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
      }
    }

    if (language && language === 'en-EN') {
      if (data.firstnameEn || data.lastnameEn) {
        fullname = `${data.firstnameEn ?? ''} ${data.lastnameEn ?? ''}`;
      } else {
        fullname = `${data.firstname ?? ''} ${data.lastname ?? ''}`;
      }
    }

    return fullname;
  };

  box = (data, classes, theme) => {
    if (data.patient) {
      const fullname = this.getFullname(localStorage.getItem('i18nextLng'), data.patient);

      return (
        <React.Fragment>
          <div className={classes.visitsNumberContainer}>
            <Grid container direction='row' justify='space-between' alignItems='center'>
              <Grid item xs={12}>
                <Typography variant='subtitle1' className={classnames(classes.materialIconText, classes.hiddenText)}>
                  {fullname}
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Typography variant='subtitle2' weight='height' className={classes.materialIconText} color='primary'>
                  <i className={data.patient.gender === 'M' ? 'fa fa-mars' : 'fa fa-venus'} />
                </Typography>
              </Grid>
              <Grid item xs={11}>
                <Typography variant='subtitle2' className={classes.materialIconText}>
                  HN-{data.patient.hn} | {data.patient.age} yr
                </Typography>
              </Grid>
            </Grid>
          </div>
          <Grid container direction='row' justify='space-between' alignItems='center'>
            <Grid container direction='row' justify='space-between' alignItems='center'>
              <Grid item xs={10}>
                {data.device && data.device.action.changed.a && data.device.action.changed.a !== 9
                  ? this.actionStatus(
                      <Tooltip title={this.getMomentValue(data.device.action.changed.a)}>
                        {this.accessibility(data.device.action.changed.a)}
                      </Tooltip>,
                    )
                  : ''}
                &nbsp;
                {data.device && data.device.action.changed.f === 3 && data.device.action.changed.a !== 9
                  ? this.actionStatus(
                      <Tooltip title='Fall'>
                        <Icons.Warning color='error' />
                      </Tooltip>,
                    )
                  : ''}
                &nbsp;
              </Grid>
              <Grid item xs={2}>
                <Typography size='md'>
                  {data.device && data.device.action.changed.a === 9 ? (
                    <img src={iconNosignal} alt='nosignal' width='30' />
                  ) : (
                    this.battery(data.device.action.changed.b)
                  )}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </React.Fragment>
      );
    } else {
      return <React.Fragment />;
    }
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleChangeMultiple = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({
      modules: value,
    });
  };

  render() {
    const dashboard = this.props.dashboard.toJS();
    const patient = this.props.patient.toJS();
    const setting = this.props.setting.toJS();
    const event = this.props.event.toJS();
    return (
      <Fragment>
        <Loader loading={dashboard.loading || setting.loading || patient.loading || event.loading} />
        <Alert contentTemplate={CustomContentTemplate} stack={true} />
        <Grid container spacing={16} alignItems='flex-start'>
          <Grid container spacing={16} item md={9} xs={12} key={1111}>
            {dashboard.user.length > 0 ? this.getContent(dashboard.user) : this.getLoaderContent()}
          </Grid>
          <Grid container spacing={0} item md={3} xs={12} key={2222}>
            <NewWarning />
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}
const styles = (theme) => ({
  paper: {
    width: '100%',
    overflowY: 'auto',
    height: '100%',
    position: 'relative',
  },
  tableTitle: {
    position: 'fixed',
    height: '56px',
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.75rem',
    fontWeight: '500',
    lineHeight: '1.3125rem',
    zIndex: 2,
    backgroundColor: 'white',
  },
  tableBody: {
    position: 'absolute',
    marginTop: '46px',
    padding: '10px',
  },
  // table: {
  //   minWidth: 650,
  // },
  warningBox: {
    position: 'fixed',
    width: '25%',
    height: '70%',
    backgroundColor: 'white',
    bottom: '10px',
    right: '2px',
  },
  titleFilter: {
    display: 'flex',
    marginBottom: '32px',
  },
  title: {
    display: 'flex',
    marginTop: '40px',
    marginBottom: '32px',
  },
  inline: {
    display: 'inline',
    marginLeft: '5px',
  },
  iconWarning: {
    color: 'rgb(255, 194, 96)',
  },
  card: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  visitsNumberContainer: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    paddingBottom: theme.spacing.unit * 2,
  },
  progressSection: {
    marginBottom: theme.spacing.unit,
  },
  progressTitle: {
    marginBottom: theme.spacing.unit * 2,
  },
  progress: {
    marginBottom: theme.spacing.unit,
    backgroundColor: theme.palette.primary.main,
  },
  pieChartLegendWrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginRight: theme.spacing.unit,
  },
  legendItemContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  fullHeightBody: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  tableWidget: {
    overflowX: 'auto',
  },
  progressBar: {
    backgroundColor: theme.palette.warning.main,
  },
  performanceLegendWrapper: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
  },
  legendElement: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing.unit * 2,
  },
  legendElementText: {
    marginLeft: theme.spacing.unit,
  },
  serverOverviewElement: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '100%',
  },
  serverOverviewElementText: {
    minWidth: 145,
    paddingRight: theme.spacing.unit * 2,
  },
  serverOverviewElementChartWrapper: {
    width: '100%',
  },
  mainChartHeader: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.only('xs')]: {
      flexWrap: 'wrap',
    },
  },
  mainChartHeaderLabels: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.only('xs')]: {
      order: 3,
      width: '100%',
      justifyContent: 'center',
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
    },
  },
  mainChartHeaderLabel: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing.unit * 3,
  },
  mainChartSelectRoot: {
    borderColor: theme.palette.text.hint + '80 !important',
  },
  mainChartSelect: {
    padding: 10,
    paddingRight: 25,
  },
  mainChartLegentElement: {
    fontSize: '18px !important',
    marginLeft: theme.spacing.unit,
  },
  materialIconText: {
    marginLeft: theme.spacing.unit * 2,
    fontSize: '16px',
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: '100%',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  reactDatepickerPopper: {
    zIndex: '9999 !important',
  },
  hiddenText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  activityBox: {
    boxShadow: 'none',
  },
  iconActivity: {
    color: 'black',
  },
});
LogActivity.propTypes = {
  classes: PropTypes.object.isRequired,
};

export const page = inject('dashboard', 'setting', 'patient', 'event', 'router', 'logActivity')(observer(LogActivity));
export default withStyles(styles, { withTheme: true })(page);
